module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/about/about.component.css
// module id = ./src/app/components/about/about.component.css
// module chunks = main